module.exports = __webpack_public_path__ + "static/media/warehouse.baafa31d.png";